import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import MetaTags from "react-meta-tags";
import {
    Container,
    Row,
    Col,
    Table,
    Card,
    CardBody,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Input,
    Button,
    Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import AreasService from "services/Admin/AreasService"
import CitiesService from "services/Admin/CitiesService"


//Import Images
import error from "assets/images/error-img.png";
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import DeleteModal from "components/Common/DeleteModal"
import { AvField, AvForm } from "availity-reactstrap-validation";
import { adminPrefix } from "configs/routePrefix";
import { toast } from "react-toastify";
import Select from "react-select";
import Language from "Enums/Language"

const languages = ["en", "ar", "zh", "ru"]

function ModalForm({
    modal,
    toggle,
    isAdd,
    editObj,
    type,
    setShouldGetData,
    setList

}) {
    const [loading, setLoading] = useState(false)
    const service = new AreasService()
    const citiesService = new CitiesService()

    const [formData, setFormData] = useState({
        en: "",
        ar: "",
        ru: "",
        zh: "",
        city: "",
        options: []

    })
    useEffect(() => {
        if (editObj ?.id) {
            service.find(editObj ?.id).then(res => {
                if (res && res.status === SuccessOk) {
                    setFormData({
                        ...formData,
                        ...res.data.name,
                        city: {
                            label: res.data.city.name.en,
                            value: res.data.city.id
                        }
                    })
                }
            })
        }
    }, [])
    const handleFieldChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };


    const handleSelectChange = (selectedOption) => {
        setFormData({ ...formData, city: selectedOption });
    };

    const handleValidSubmit = (_, values) => {
        let data = {
            city_id: formData.city.value
        }
        setLoading(true)
        if (isAdd) {
            let data = {
                city_id: formData.city.value,
                name: {
                    en: formData.en,
                },
            }
            languages.forEach(language => {
                if (formData[language].length) {
                    data.name[language] = formData[language]
                }
            })
            service.create(data).then(res => {
                if (res && res.status === SuccessCreated) {
                    setShouldGetData(true)
                    toast.success("Location Added successfully")
                    toggle()
                }else{
                    setLoading(false)
                    toast.error(res)
                }
            })
        } else {
            let data = {
                city_id: formData.city.value,
                name: {
                    en: formData.en,
                    ar: formData.ar,
                    ru: formData.ru,
                    zh: formData.zh
                },
            }
            service.update(editObj.id, data).then(res => {
                if (res && res.status === SuccessOk) {
                    setShouldGetData(true)
                    toast.success("Location Edited Successfully")
                    toggle()
                }else{
                    setLoading(false)
                    toast.error(res)
                }

            })
        }
    }
    useEffect(() => {
        citiesService.getDropDown().then(res => {
            const newOptions = res.data.map(item => {
                return {
                    label: item.name.en,
                    value: item.id
                }
            })
            setFormData(data => ({ ...data, options: [...newOptions] }))
        })
    }, [])
    return (
        <Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
            <ModalHeader toggle={toggle}>
                {isAdd ? `Add New ${type} ` : `Update ${type}`}
            </ModalHeader>
            <ModalBody>
                <AvForm
                    className='form-horizontal'
                    onValidSubmit={(e, v) => {
                        handleValidSubmit(e, v);
                    }}>
                    <Row  >
                        {Language.LIST.map((lan, index) => {
                            return (
                                <Col md={6} key={index} >
                                    <AvField
                                        className="mb-3"
                                        name={lan.name}
                                        label={lan.label}
                                        bsSize="lg"
                                        value={formData[`${lan.name}`]}
                                        onChange={(e => handleFieldChange(e))}
                                        validate={{
                                            required: {value: lan.name === "en" ? true : false, errorMessage: 'This Field is required'},
                                            pattern: {value: lan.name === "en" ? '/^[A-Za-z ]+$/' : lan.name === "ar" ? '/^[\u0621-\u064A ]+$/' : "", errorMessage: `${lan.name=='en' ? "English" : "Arabic"} format is invalid`}
                                        }}
                                        placeholder={lan.name === "en" ? 'eg.. cairo' : lan.name === "ar" ? "القاهرة" : lan.name === "zh" ? "開羅" : "Каир"}

                                    />
                                </Col>
                            )
                        })}
                    </Row>

                    {/*   <Row className="mb-4">
                        <Col md={6}>
                            <div className='mb-3'>
                                <AvField
                                    name='en'
                                    label="English"
                                    className='form-control'
                                    placeholder='cairo'
                                    required
                                    onChange={(e) => handleFieldChange(e)}
                                    value={formData.en}
                                    bsSize="lg"

                                />
                            </div>

                        </Col>
                        <Col md={6}>
                            <div className='mb-3'>
                                <AvField
                                    name='ar'
                                    label="Arabic"
                                    className='form-control'
                                    placeholder='القاهرة'
                                    required
                                    onChange={(e) => handleFieldChange(e)}
                                    value={formData.ar}
                                    bsSize="lg"

                                />
                            </div>

                        </Col>
                    </Row><Row className="mb-4">
                        <Col md={6}>
                            <div className='mb-3'>
                                <AvField
                                    name='ru'
                                    label="Russian"
                                    className='form-control'
                                    placeholder='Каир'
                                    required
                                    onChange={(e) => handleFieldChange(e)}
                                    value={formData.ru}
                                    bsSize="lg"

                                />
                            </div>

                        </Col>
                        <Col md={6}>
                            <div className='mb-3'>
                                <AvField
                                    name='zh'
                                    label="Chinese"
                                    className='form-control'
                                    placeholder='開羅'
                                    required
                                    onChange={(e) => handleFieldChange(e)}
                                    value={formData.zh}
                                    bsSize="lg"


                                />
                            </div>

                        </Col>
                    </Row>*/}
                    <Row>
                        <Col md={6}>
                            <label>City</label>
                            <Select
                                name='City'
                                placeholder='eg.. City'
                                options={formData.options}
                                className='mb-3 p-1'
                                onChange={handleSelectChange}
                                value={formData.city}
                            />
                        </Col>
                    </Row>
                    <ModalFooter className="px-0">
                        <button
                            disabled={loading ? true : false}

                            type='submit' className='btn btn-success w-100'>
                            {isAdd ? "Add Location" : "Update Location"}
                        </button>
                    </ModalFooter>
                </AvForm>
            </ModalBody>
        </Modal>
    );
}

export default ModalForm;
